module.exports = __webpack_public_path__ + "media/images/illustrations/living_room_small-eb94fad77f0c274fd5920314f80fca5a.svg";